// Raw API input type
type TUserInput = {
    username: string
    approved: boolean
    name: string
    email: string
    mfa: boolean
    initials: string
    is_dno_reviewer: boolean
    is_dno_approved: boolean
    is_dno_admin: boolean
    is_dno_reporting: boolean
    is_dno_threshold_manager: boolean
    is_lct_manu_approved: boolean
    is_lct_manu_admin: boolean
    is_installer_admin: boolean
    is_installer_approved: boolean
    is_sys_admin: boolean
    is_insights_reader: boolean
    is_insights_author: boolean
    type: string
}
type TUsersInput = TUserInput[]

// Paginated API response type
type TPaginatedUsersInput = {
    users: TUsersInput
    total_count: number
    page_size: number
    next_token: string | null
}

// Mapper Output type
export type TUserOutput = {
    userName: string
    approved: boolean
    fullName: string
    email: string
    mfa: boolean
    initials: string
    isDnoReviewer: boolean
    isDnoApproved: boolean
    isDnoAdmin: boolean
    isDnoThresholdManager: boolean
    isLctManuApproved: boolean
    isLctManuAdmin: boolean
    isInstallerAdmin: boolean
    isInstallerApproved: boolean
    isSysAdmin: boolean
    isInsightsReader: boolean
    isInsightsAuthor: boolean
    type: string
}

export type TUsersOutput = TUserOutput[]

export type TPaginatedUsersOutput = {
    users: TUsersOutput
    totalCount: number
    pageSize: number
    nextToken: string | null
}

const mapUsers = (usersInput: TUsersInput): TUsersOutput =>
    usersInput.map((user) => ({
        userName: user?.username,
        approved: user?.approved,
        fullName: user?.name || "Unable to find name",
        email: user?.email,
        mfa: user?.mfa,
        initials: user?.initials,
        isDnoReviewer: user?.is_dno_reviewer,
        isDnoApproved: user?.is_dno_approved,
        isDnoAdmin: user?.is_dno_admin,
        isDnoThresholdManager: user?.is_dno_threshold_manager,
        isLctManuApproved: user?.is_lct_manu_approved,
        isLctManuAdmin: user?.is_lct_manu_admin,
        isInstallerAdmin: user?.is_installer_admin,
        isInstallerApproved: user?.is_installer_approved,
        isSysAdmin: user?.is_sys_admin,
        isInsightsReader: user?.is_insights_reader,
        isInsightsAuthor: user?.is_insights_author,
        type: user?.type,
    }))

// Overall output type
type TUsersMapper = {
    map: (response: unknown) => TUsersOutput
}

type TPaginatedUsersMapper = {
    map: (response: unknown) => TPaginatedUsersOutput
}

export const userMapper: TUsersMapper = {
    map: (response: unknown): TUsersOutput => {
        // to do call is tusersinput type guard
        // if false throw error
        if (!Array.isArray(response)) {
            throw Error()
        }
        const resTyped = response as TUsersInput
        return mapUsers(resTyped)
    },
}

export const paginatedUserMapper: TPaginatedUsersMapper = {
    map: (response: unknown): TPaginatedUsersOutput => {
        const res = response as TPaginatedUsersInput
        if (!res || !Array.isArray(res.users)) {
            throw Error()
        }
        return {
            users: mapUsers(res.users),
            totalCount: res.total_count,
            pageSize: res.page_size,
            nextToken: res.next_token,
        }
    },
}
